<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="harvestingFloralVarietyForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                harvestingFloralVarietyForm: () => import('../forms/HarvestingFloralVarietyForm'),
                headers: [
                    { text: 'Harvesting', value: 'harvestingId', table: 'harvestings', form: () => import('../forms/HarvestingForm') },
                    { text: 'Floral Variety', value: 'floralVarietyId', table: 'floralVarieties', form: () => import('../forms/FloralVarietyForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    floralVarieties: [],
                    harvestings: [],
                    items: []
                },
                sorting: [
                    { column: "harvestingId", direction: "ascending" },
                    { column: "floralVarietyId", direction: "ascending" },
                ],
                itemsField: 'harvestingFloralVarieties',
                editPageName: 'harvestingFloralVariety',
                apiMethod: 'HarvestingFloralVarieties',
                claimName: 'HarvestingFloralVarieties',
                formTitle: 'Harvesting Floral Variety',
                excelTitle: 'Harvesting Floral Varieties',
                hasEditPage: false,
            }
        },
    };
</script>
